import styled from 'styled-components'

import { ThemeModeType } from '@application/Types/ComponentTypes'

export const Title = styled.h2`
    ${(props) => props.theme.typo.displayL};
    ${(props) => props.theme.fontWeight.medium};
    margin-bottom: 20px;
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    margin-bottom: 32px;
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    background-color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.p600 : props.theme.color.g100)};
    padding: 50px 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 100px 0;
    }

    ${Title} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.p500)};
    }

    ${Description} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.g100 : props.theme.color.g600)};
    }
`
